import { toast } from "sonner";
import request from "../../../../helpers/request";
import { IDeleteConfigPtMonDigital } from "./types";

export const deleteConfigPtMonDigital = async ({
  adrModulo,
  idCentral,
  idEntrada,
}: IDeleteConfigPtMonDigital) => {
  const url = `${process.env.REACT_APP_API}/MonDigital/DeleteConfig/${idCentral}/${adrModulo}/${idEntrada}`;
  const result = await request({ url, method: "delete" });

  if (result.status !== 200) {
    toast.error("Houve um erro ao excluir configuração!");
    return {
      status: result.status,
      data: result.data,
    };
  }

  if (result.status === 200) {
    toast.success("Configuração excluída com sucesso!");
    return result.data;
  }
};
